import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    position: 'relative',

    display: 'flex',
    flexDirection: 'column',

    height: '100%',
    width: '100%',
});

export const viewingAsFrame: TRuleWithTheme = ({ theme }) => ({
    // Drawn as an overlay so the frame doesn't consume layout space or shift content.
    '::after': {
        content: '""',
        position: 'absolute',
        inset: 0,
        zIndex: 9,
        border: `4px solid ${theme.colors.accentPrimary}`,
        pointerEvents: 'none',
    },
});

export const listWrapper: TRuleWithTheme = () => ({
    position: 'relative',

    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 0,
});

export const extensionPasskeysPrompt: TRuleWithTheme = ({ theme }) => ({
    marginTop: theme.spacing(16),

    marginLeft: theme.spacing(16),
    marginRight: theme.spacing(16),

    min768: {
        marginTop: theme.spacing(16),
        marginBottom: theme.spacing(16),
        marginLeft: theme.spacing(40),
        marginRight: theme.spacing(40),
    },
});
